import { Bezier } from "../../maths/Bezier";
import { ClassUtils } from "../../utils/ClassUtils";
import { Pool } from "../../utils/Pool";
const className = "DrawCurvesCmd";
export class DrawCurvesCmd {
    static create(x, y, points, lineColor, lineWidth) {
        var cmd = Pool.getItemByClass(className, DrawCurvesCmd);
        cmd.x = x;
        cmd.y = y;
        cmd.points = points;
        cmd.lineColor = lineColor;
        cmd.lineWidth = lineWidth;
        return cmd;
    }
    recover() {
        this.points = null;
        this.lineColor = null;
        Pool.recover(className, this);
    }
    run(runner, gx, gy) {
        if (this.points)
            runner.drawCurves(this.x + gx, this.y + gy, this.points, this.lineColor, this.lineWidth);
    }
    get cmdID() {
        return DrawCurvesCmd.ID;
    }
    getBounds(assembler) {
        Bezier.getPoints(this.points, 5, 2, assembler.points);
        assembler.flushPoints(this.x, this.y);
    }
}
DrawCurvesCmd.ID = className;
ClassUtils.regClass(className, DrawCurvesCmd);
